var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 43,
    viewBox: "0 0 53 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5349 42.1472H16.5347C11.5363 42.1498 6.62968 40.8997 2.2619 38.5275C2.41613 38.5309 2.57039 38.5328 2.7247 38.533C7.64121 38.5408 12.4175 36.901 16.2843 33.8774L17.3914 33.0118L15.9863 32.9837C13.8643 32.9412 11.8087 32.2403 10.1064 30.9792C8.62691 29.883 7.47856 28.4112 6.77694 26.725C8.17634 26.8832 9.59596 26.7752 10.9595 26.4038L10.9264 25.4311C8.62344 24.9696 6.55257 23.7286 5.06553 21.9196C3.72543 20.2893 2.93395 18.2883 2.7917 16.1985C4.13955 16.8121 5.59917 17.1539 7.08602 17.2008L8.83769 17.2562L7.37893 16.2849C5.22827 14.8529 3.70661 12.6599 3.12247 10.1521C2.59301 7.87897 2.86959 5.50122 3.89236 3.4175C6.53158 6.49094 9.75703 9.01622 13.3844 10.8457C17.234 12.7872 21.4504 13.9017 25.7603 14.1169L26.4222 14.15L26.2723 13.5044C25.7684 11.3351 25.9964 9.06094 26.9212 7.03338C27.846 5.00579 29.4163 3.33747 31.3897 2.28676C33.3631 1.23602 35.6296 0.8616 37.8385 1.22159C40.0474 1.58158 42.0753 2.65584 43.6087 4.27779L43.7981 4.47813L44.0686 4.42487C46.0506 4.03464 47.9667 3.37425 49.7634 2.46408C48.9018 4.25645 47.5266 5.76863 45.7969 6.80075L46.1105 7.72681C47.6945 7.54363 49.2514 7.18606 50.7529 6.6618C49.5487 8.17541 48.1395 9.51929 46.5633 10.654L46.3438 10.8119L46.3559 11.0821C46.3759 11.5294 46.3859 11.987 46.3859 12.4347C46.3859 26.247 35.8212 42.1472 16.5349 42.1472Z",
    fill: "white",
    stroke: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.63a732ce7a1ce904b0749ff296e8bf30.svg";
export { ForwardRef as ReactComponent };